import { render, staticRenderFns } from "./ChooseExamForm.vue?vue&type=template&id=396041b0&scoped=true"
import script from "./ChooseExamForm.vue?vue&type=script&lang=js"
export * from "./ChooseExamForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "396041b0",
  null
  
)

export default component.exports